import type { UxrrLogger } from '@zyno-io/uxrr-client';

import { uxrr } from '@zyno-io/uxrr-client';

function createLazyLogger(scope: string): UxrrLogger {
    let _logger: UxrrLogger | undefined;

    function call(level: 'debug' | 'info' | 'warn' | 'error', msg: string, args: unknown[]) {
        if (!_logger) _logger = uxrr.createLogger(scope);
        if (_logger) {
            _logger[level](msg, ...args);
        } else {
            (level === 'info' ? console.log : console[level])(`[ZS:${scope}]`, msg, ...args);
        }
    }

    return {
        debug: (msg: string, ...args: unknown[]) => call('debug', msg, args),
        info: (msg: string, ...args: unknown[]) => call('info', msg, args),
        warn: (msg: string, ...args: unknown[]) => call('warn', msg, args),
        error: (msg: string, ...args: unknown[]) => call('error', msg, args),
        createScoped(name: string, data?: Record<string, unknown>) {
            if (!_logger) _logger = uxrr.createLogger(scope);
            return _logger?.createScoped(name, data) ?? createLazyLogger(`${scope}/${name}`);
        }
    };
}

export const Logger = {
    createScoped: (scope: string) => createLazyLogger(scope)
};
